import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import errorHandler from "../../../../components/unauthorizeHandler";

export function* handleFetchVarianceStatuses({ data }) {

  try {
    const response = yield axios.get(`${baseURL}/variance-status`, {
    });
    if (response.status === 200) {
      yield put(actions.fetchVarianceStatusesSuccess(response.data));
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchVarianceStatusesError());
    AntdAlert.error("Something went wrong!");
    console.log(error);
  }
}

export function* handleUpdateVarianceStatuses({ data }) {
  const { color, id, statusName, completedStatus } = data;
  try {
    const response = yield axios.patch(
      `${baseURL}/variance-status/${id}`,
      {
        completedStatus,
        statusName,
        color,
      }
    );
    if (response.status === 200) {
      AntdAlert.success("Variance Status Updated Successfully");
      yield put(actions.updateVarianceStatusesSuccess(data));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.updateVarianceStatusesError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateVarianceStatusesError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleDeleteVarianceStatuses({ data }) {
  const { id } = data;
  try {
    const response = yield axios.delete(
      `${baseURL}/variance-status/${id}`
    );

    if (response.status === 200) {
      AntdAlert.success("Variance Status Deleted Successfully");
      yield put(actions.deleteVarianceStatusesSuccess(id));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.deleteVarianceStatusesError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.deleteVarianceStatusesError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleCreateVarianceStatuses({ data }) {
  try {
    const newData = JSON.parse(JSON.stringify(data));
    delete newData.id;
    const response = yield axios.post(`${baseURL}/variance-status`, {
      ...newData,
    });
    if (response.status === 201) {
      AntdAlert.success("Variance Status Created Successfully");
      yield put(actions.createVarianceStatusesSuccess(response.data));
      console.log(response.data);
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.createVarianceStatusesError(data.id));
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleUpdateVarianceOrder({ data }) {
  const varianceStatusObj = {};

  data.forEach((el, i) => {
    varianceStatusObj[el.id] = i;
  });

  const payload = {
    varianceStatus: varianceStatusObj
  };
  try {
    const response = yield axios.post(
      `${baseURL}/variance-status/sort`,
      payload
    );

    if (response.status === 201) {
      AntdAlert.success("Variance Status Order Updated Successfully");
      yield put(actions.updateVariancesOrderSuccess(data));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.updateVariancesOrderError());
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateVariancesOrderError());
    // AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleSetCompletedStatus({ data }) {
  const { currentStatus, otherStatuses } = data;
  try {
    for (const status of otherStatuses) {
      yield axios.patch(`${baseURL}/variance-status/${status.id}`, {
        ...status,
        completedStatus: false,
      });
    }

    yield axios.patch(`${baseURL}/variance-status/${currentStatus.id}`, {
      ...currentStatus,
      completedStatus: true,
    });

    yield put(actions.fetchVarianceStatuses());
    AntdAlert.success("Completed status updated successfully");
  } catch (error) {
    console.error("Error setting completed status:", error);
    AntdAlert.error("Failed to update completed status");
  }
}
